import styled from "styled-components";


export const SpanLucroProfissional = styled.span<{ corLucro: string; corLucroBackground: string }>`
    font-size: 11px;
    color: ${({ corLucro }) => corLucro};
    font-weight: 500;
    border: 1px solid ${({ corLucro }) => corLucro};
    border-radius: 10px;
    padding: 3px 10px;
    margin-left: 0;
    text-transform: none;
    background-color: ${({ corLucroBackground }) => corLucroBackground};
    white-space: nowrap;
`;

export const ContainerTooltip = styled.div`
    position: relative;
    display: inline-block;
`;

export const Tooltip = styled.div`
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background: ${({ theme }) => theme.colors?.interfaceGray700 || '#333'};
    color: ${({ theme }) => theme.colors?.interfacePure0 || '#fff'};
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 8px;
    white-space: nowrap;
    box-shadow: 0 4px 12px rgba(0,0,0,0.18);
    z-index: 20;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-width: 6px;
        border-style: solid;
        border-color: ${({ theme }) => theme.colors?.interfaceGray700 || '#333'} transparent transparent transparent;
    }
`;

export const InputContainer = styled.div`
    flex: 1;
    padding-left: 10px;
    
    .default-input {
        min-height: auto;
        height: auto;
        margin-top: 0;
        
        input {
            height: 32px;
            padding: 6px 12px;
            margin-top: 0;
            font-size: 14px;
            border-radius: 6px;
            border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
            transition: border-color 0.2s ease;
            background: ${(props: any) => props.theme.colors.white};
            color: ${(props: any) => props.theme.colors.interfaceText500};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
                outline: none;
            }
        }
        
        &.error input {
            border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
                outline: none;
            }
        }
    }
    
    > label {
        height: auto;
        min-height: auto;
        
        input {
            height: 32px;
            padding: 6px 12px;
            margin-top: 0;
            font-size: 14px;
            border-radius: 6px;
            border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
            transition: border-color 0.2s ease;
            background: ${(props: any) => props.theme.colors.white};
            color: ${(props: any) => props.theme.colors.interfaceText500};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
                outline: none;
            }
        }
        
        &.error input {
            border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
                outline: none;
            }
        }
    }
`;